import React from "react";

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/equipe.jpg" className="img-responsive" alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>À propos de nous</h2>
              <p>La Fédération des Associations de la Province de Jerada a été 
                créée en 2010, avec la participation de plus de 45 associations 
                au niveau de la Province de Jerada, les activités de la fédération sont
 : </p>
             
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                  <li>activités culturelles</li>
             <li>activités sportives</li>
             <li>activités sociales</li>
             <li> activités  organisation des festivals</li>
            
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                  <li>femmes</li>
             <li>enfants</li>
             <li> jeunesse</li>
             <li>soutien dcolaire</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
